"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var IndexedInvestmentOption_1 = require("./IndexedInvestmentOption");
var _ = require("lodash");
var IndexedInvestmentOptionList = (function () {
    function IndexedInvestmentOptionList() {
        this._list = [];
    }
    IndexedInvestmentOptionList.prototype.initialise = function (list, indexationBasis) {
        for (var i = 1; i <= list.numberOfInvestmentOptions; i++) {
            var indexedInvestmentOption = new IndexedInvestmentOption_1.IndexedInvestmentOption();
            indexedInvestmentOption.initialise(list.getOptionAtPosition(i), indexationBasis);
            this._list.push(indexedInvestmentOption);
        }
    };
    IndexedInvestmentOptionList.prototype.annualUpdate = function (year) {
        for (var i = 0; i < this._list.length; i++) {
            var indexedInvestmentOption = this._list[i];
            indexedInvestmentOption.index(year);
        }
    };
    IndexedInvestmentOptionList.prototype.getOptionAtPosition = function (position) {
        return this._list[position - 1];
    };
    IndexedInvestmentOptionList.prototype.getOptionWithName = function (name) {
        return _.find(this._list, function (o, i) { return o.name === name; });
    };
    IndexedInvestmentOptionList.prototype.getIndexForOptionWithName = function (name) {
        return _.findIndex(this._list, function (o, i) { return o.name === name; });
    };
    return IndexedInvestmentOptionList;
}());
exports.IndexedInvestmentOptionList = IndexedInvestmentOptionList;
//# sourceMappingURL=IndexedInvestmentOptionList.js.map